import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#9ACB41',
        orange: '#F8B140',
        blue: '#20b2dd',
        black: '#000000',
        purple: '#7F3179',
        red: '#CB4155',
        Success: '#9ACB41',
        Failure: '#CB4155',
        pass: '#9ACB41',
        fail: '#CB4155',
        unknown: '#DDDDDD',
        running: '#20b2dd',
        error: '#CB4155'
      }
    }
  }
}

export default new Vuetify(opts)
